import { createApiClient } from '@dru/api-client';

/**
 * One client for the app.
 *
 * Same-origin `/api/v1` in both development (through the Vite proxy) and
 * production, so the HttpOnly refresh cookie behaves identically in each —
 * a cross-origin setup only in development is how SameSite surprises get
 * discovered after deploy.
 *
 * `VITE_API_BASE` overrides it for the split-origin deployment docs/17
 * describes. See the employee app's copy of this file for what that costs.
 */
export const API_BASE: string = import.meta.env?.VITE_API_BASE ?? '/api/v1';
export const api = createApiClient(API_BASE);
